import { render, staticRenderFns } from "./knowledgeBaseRepository.vue?vue&type=template&id=8a45533e&scoped=true"
import script from "./knowledgeBaseRepository.vue?vue&type=script&lang=js"
export * from "./knowledgeBaseRepository.vue?vue&type=script&lang=js"
import style0 from "./knowledgeBaseRepository.vue?vue&type=style&index=0&id=8a45533e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a45533e",
  null
  
)

export default component.exports